import { CSSProperties, ReactNode } from 'react';
import { useDynamicFieldInsertion, useEmptySpaceInsertion } from '../../hooks';
import { DynamicFieldAction, DynamicFieldAttributes } from '../../molecules/dynamic-field-action';
import { DynamicFieldPlugin } from '../../plugins/dynamic-field';

type Props = {
  buttonLabel?: ReactNode;
  fields: DynamicFieldAttributes[];
  noTransform?: boolean;
  onCustomSelect?: (dynamicField: DynamicFieldAttributes) => void;
  styles?: CSSProperties;
};
export const DynamicField = ({ buttonLabel, fields, noTransform, onCustomSelect, styles: dynamicStyles }: Props) => {
  const insertDynamicField = useDynamicFieldInsertion();
  const insertEmptySpace = useEmptySpaceInsertion();

  return (
    <>
      <DynamicFieldAction
        label={buttonLabel}
        fields={fields}
        onSelect={(selectedDynamicField) => {
          // use the custom select cb instead of inserting the dynamic field
          if (selectedDynamicField?.customSelect) {
            onCustomSelect?.(selectedDynamicField);
            return;
          }
          insertDynamicField(selectedDynamicField, noTransform, dynamicStyles);
          insertEmptySpace();
        }}
      />
      <DynamicFieldPlugin fields={fields} noTransform={noTransform} />
    </>
  );
};
